<header class="bg-zinc-50 border-b border-zinc-100 flex items-center h-16 lg:h-20">
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between">
      <div class="breakpoint-3xl">
        <img
          width="160"
          height="44"
          class="w-[120px] sm:w-[140px] lg:w-[160px] h-auto"
          src="assets/images/calenso-logo.webp"
          alt="Calenso Outreach"
        />
      </div>

      <div class="hidden md:flex items-center gap-4 lg:gap-6 xl:gap-9">
        <a
          (click)="scrollToSection('overview')"
          (keyup.enter)="scrollToSection('overview')"
          (keyup.space)="scrollToSection('overview')"
          tabindex="0"
          class="text-black font-semibold text-sm lg:text-base xl:text-lg cursor-pointer hover:text-indigo-600 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded-sm px-2 py-1 transition-all"
        >
          Übersicht
        </a>

        <a
          (click)="scrollToSection('functions')"
          (keyup.enter)="scrollToSection('functions')"
          (keyup.space)="scrollToSection('functions')"
          tabindex="0"
          class="text-black font-semibold text-sm lg:text-base xl:text-lg cursor-pointer hover:text-indigo-600 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded-sm px-2 py-1 transition-all"
        >
          Funktionen
        </a>
        <a
          (click)="scrollToSection('referenzen')"
          (keyup.enter)="scrollToSection('referenzen')"
          (keyup.space)="scrollToSection('referenzen')"
          tabindex="0"
          class="text-black font-semibold text-sm lg:text-base xl:text-lg cursor-pointer hover:text-indigo-600 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded-sm px-2 py-1 transition-all"
        >
          Referenzen
        </a>
      </div>

      <div>
        <app-book-demo-button />
      </div>
    </div>
  </div>
</header>
